import { createGlobalStyle } from "styled-components";
import { PRIMARY_FONT, PRIMARY_COLOR, LIGHT_BACKGROUND_COLOR } from '@shared/constants'

export const GlobalStyle = createGlobalStyle`
  *,
  *::after,
  *::before {
    margin: 0;
    padding: 0;
    box-sizing: inherit;
    font-family: ${PRIMARY_FONT};
    color: ${PRIMARY_COLOR};
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    background-color: ${LIGHT_BACKGROUND_COLOR};
  }
`;
